import { topics as topicCatalog } from '@/data/topics';
import type { Topic } from '@/models/topic';
import type { TopicDoc } from '@/types/backend-contracts';

export function toTopicViewModel(topic: TopicDoc & { id: string }): Topic {
  const catalogTopic = topicCatalog.find((entry) => entry.id === topic.slug || entry.id === topic.id);

  if (!catalogTopic) {
    throw new Error(`Topic visual metadata not found for ${topic.id}.`);
  }

  return {
    id: topic.id,
    label: topic.name,
    description: catalogTopic.description,
    keywords: [...catalogTopic.keywords],
    questionFocus: catalogTopic.questionFocus,
    positionFocus: catalogTopic.positionFocus,
    missingFocus: catalogTopic.missingFocus,
    icon: catalogTopic.icon,
    positionStatements: catalogTopic.positionStatements,
  };
}
